module.exports = __webpack_public_path__ + "d96e75aad79081d2c244a179d395e871.pdf";